import { easeCurves } from "../eases/eases";
import { css } from 'styled-components'; // limit the direction to the only ones we support:

var OPACITY_DEFAULT = 0;
var OPACITY_ACTIVE = 1;
var OFFSET_ACTIVE = '0%';
var OFFSET_DEFAULT = '70%';
var DURATION_ACTIVE = 400;
var DURATION_DEFAULT = 250;
/**
 * A simple slide transition can toggle if "active" or not as well as selecting a driection.
 * Available css variables for consumption by children:
 * ```
 * --vapor-slide-transition-ease
 * --vapor-slide-transition-duration
 * --vapor-slide-x
 * --vapor-slide-y
 *```
 * Optional configurations:
 * @param {SlideDirection} [direction='left']
 * @param {number} [props.opacityActive=1]
 * @param {number} [props.opacityDefault=0]
 * @param {string} [props.offsetActive='0%']
 * @param {string} [props.offsetDefault='70%']
 * @param {number} [props.durationActive = 400]
 * @param {number} [props.durationDefault = 250]
 *
 * @example
 * const MyComponent = styled.div<{isActive: boolean;}>`
 *  ${transitionSlide('center')}
 * `;
 *
 * @param {boolean} isActive toggles transition between the two states.
 *
 *```jsx
 * <MyComponent isActive={true} >
 * {...children}
 * </MyComponent>
 *```
 */

export var transitionSlide = function transitionSlide() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _props$opacityActive = props.opacityActive,
      opacityActive = _props$opacityActive === void 0 ? OPACITY_ACTIVE : _props$opacityActive,
      _props$opacityDefault = props.opacityDefault,
      opacityDefault = _props$opacityDefault === void 0 ? OPACITY_DEFAULT : _props$opacityDefault,
      _props$offsetActive = props.offsetActive,
      offsetActive = _props$offsetActive === void 0 ? OFFSET_ACTIVE : _props$offsetActive,
      _props$offsetDefault = props.offsetDefault,
      offsetDefault = _props$offsetDefault === void 0 ? OFFSET_DEFAULT : _props$offsetDefault,
      _props$durationActive = props.durationActive,
      durationActive = _props$durationActive === void 0 ? DURATION_ACTIVE : _props$durationActive,
      _props$durationDefaul = props.durationDefault,
      durationDefault = _props$durationDefaul === void 0 ? DURATION_DEFAULT : _props$durationDefaul;
  return css(["--vapor-slide-transition-ease:", ";--vapor-slide-transition-duration:", ";--vapor-slide-x:", ";--vapor-slide-y:", ";opacity:", ";transform:translate3d(var(--vapor-slide-x),var(--vapor-slide-y),0px);transition-property:transform,opacity;transition-timing-function:var(--vapor-slide-transition-ease);transition-duration:var(--vapor-slide-transition-duration);"], function (p) {
    return p.isActive ? easeCurves.easeOutQuint : easeCurves.decelerate;
  }, function (p) {
    return p.isActive ? "".concat(durationActive, "ms") : "".concat(durationDefault, "ms");
  }, function (p) {
    if (direction === 'left' && !p.isActive) {
      return "-".concat(offsetDefault);
    }

    if (direction === 'right' && !p.isActive) {
      return offsetDefault;
    }

    return '0%';
  }, function (p) {
    if (direction === 'top' && !p.isActive) {
      return "-".concat(offsetDefault);
    }

    if (direction === 'bottom' && !p.isActive) {
      return offsetDefault;
    }

    return offsetActive;
  }, function (p) {
    return p.isActive ? opacityActive : opacityDefault;
  });
};